var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kosmo-select',{attrs:{"label":"Nacionalidade *","items":_vm.nationalities,"value":_vm.value,"rules":_vm.rules,"disabled":_vm.disabled},on:{"input":value => _vm.$emit('input', value)}})
}
var staticRenderFns = []

export { render, staticRenderFns }